/* unplugin-vue-components disabled */import { render } from "./QuickScaleAnswerItem.vue?vue&type=template&id=4cf5d633&scoped=true"
import script from "./QuickScaleAnswerItem.vue?vue&type=script&lang=js"
export * from "./QuickScaleAnswerItem.vue?vue&type=script&lang=js"

import "./QuickScaleAnswerItem.vue?vue&type=style&index=0&id=4cf5d633&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf5d633"]])

export default __exports__